// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-date-picker-docs',
    templateUrl: './date-picker.docs.generated.html',
})
export class UIDatePickerDocs { }
